import Cookies from 'js-cookie';
import { session_domain } from '@/config';

export const getAccessToken = () => {
  return Cookies.get('at');
};

export const removeAccessToken = () => {
  Cookies.remove('at', { domain: session_domain });
};

export const saveAccessToken = (accessToken, exp) => {
  Cookies.set('at', accessToken, { expires: exp, domain: session_domain });
};

export const removeAuthTokens = () => {
  removeAccessToken();
  removeWorkspaceId();
};

export const getWorkspaceId = () => {
  return Cookies.get('wsId', { domain: session_domain });
};

export function removeWorkspaceId() {
  return Cookies.remove('wsId', { domain: session_domain });
}

export const saveWorkspaceId = (wsId, exp = 30) => {
  return Cookies.set('wsId', wsId, { expires: exp, domain: session_domain });
};